import { useParams } from "react-router-dom";
import PrescriptionDisplay from "../../components/history/display/PrescriptionDisplay";

const PrescriptionPage = () => {
  const { code } = useParams();

  return (
    <PrescriptionDisplay code={code} />
  );
};

export default PrescriptionPage;